import { render, staticRenderFns } from "./AdminStatusChanger.vue?vue&type=template&id=03c16ad2"
import script from "./AdminStatusChanger.vue?vue&type=script&lang=ts"
export * from "./AdminStatusChanger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports